import React, { useState, useEffect } from "react";
import { Dropdown, DropdownProps } from "semantic-ui-react";
import classNames from "classnames";
import { connectField } from "uniforms";

import { SelectFieldProps } from "./SelectField.d";

export function selectFieldOptionMapper(options: string[]) {
  return (options || []).map(option => ({ value: option, text: option }));
}

function initializeOptions(
  options?: SelectFieldProps["options"] | string[],
  transform?: SelectFieldProps["transform"]
) {
  return transform
    ? (options || []).map(opt => {
        const allowedValue = opt.value || opt;
        return {
          value: allowedValue,
          text: transform(allowedValue)
        };
      })
    : options;
}

export const SelectField = ({
  className,
  clearable,
  allowAdditions,
  disabled,
  id,
  inputRef,
  label,
  search,
  onChange,
  placeholder,
  required,
  error,
  multiple,
  options, // [ {key, text, value}]
  transform,
  value = "",
  loading
}: SelectFieldProps) => {
  const [optionList, setOptionList] = useState<DropdownProps["options"]>([]);
  const [hasAddedOptions, setHasAddedOptions] = useState<boolean>(false);
  const handleAddition = (e, { value: addedValue }: DropdownProps) => {
    setOptionList([{ text: addedValue, value: addedValue }, ...optionList]);
    setHasAddedOptions(true);
  };

  useEffect(() => {
    if (hasAddedOptions) return;
    const opts = initializeOptions(options, transform);
    setOptionList(opts);
  }, [options, transform]);
  return (
    <div
      className={classNames("field", className, { required, error })}
      style={{ marginBottom: "10px" }}
    >
      {label && <label htmlFor={id}>{label}</label>}

      <Dropdown
        id={id}
        disabled={disabled}
        loading={loading}
        clearable={clearable}
        ref={inputRef}
        required={required}
        multiple={multiple}
        allowAdditions={allowAdditions}
        onAddItem={handleAddition}
        fluid
        search={search}
        selection
        value={value}
        options={optionList}
        label={label}
        placeholder={placeholder}
        onChange={(_, { value: changedValue }) => {
          onChange(changedValue);
        }}
      />
    </div>
  );
};

export default connectField<SelectFieldProps>(SelectField);
